var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('br'),_c('CelmodeButton',{on:{"click":function($event){return _vm.closeAll()}}},[_vm._v(" Close All ")]),_c('ObjectEditor',{attrs:{"path":[]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }